import React from 'react';

// Inline animated SVG illustrations for the install steps, one per step.
// Ported from the web-install-flow reference. Keyframes (sh-*) are defined in
// _lead-finder-extension-modal.scss. Decorative artwork — fixed palette.

// Step 1 — Download the ZIP file (cloud → file → Downloads folder)
export const DownloadIllustration: React.FC = () => (
  <svg viewBox="0 0 280 140" className="bs-lf-ext__svg" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="280" height="140" rx="10" fill="#FAF8F4" />

    {/* Cloud (left) */}
    <g transform="translate(24, 6)">
      <path d="M14 24a9 9 0 0 1 8-13 13 13 0 0 1 25 1 8 8 0 0 1 4 15H14a9 9 0 0 1 0-3z" fill="#E8F0FF" stroke="#1976FF" strokeWidth="1.5" />
    </g>

    {/* Falling bytes */}
    <g style={{ animation: 'sh-float-down 1.8s ease-in infinite' }}>
      <rect x="52" y="46" width="3" height="3" rx="0.5" fill="#1976FF" opacity="0.7" />
    </g>
    <g style={{ animation: 'sh-float-down 1.8s ease-in infinite', animationDelay: '0.5s' }}>
      <rect x="61" y="46" width="3" height="3" rx="0.5" fill="#1976FF" opacity="0.7" />
    </g>
    <g style={{ animation: 'sh-float-down 1.8s ease-in infinite', animationDelay: '1s' }}>
      <rect x="70" y="46" width="3" height="3" rx="0.5" fill="#1976FF" opacity="0.7" />
    </g>

    {/* File icon with Saleshandy logo */}
    <g transform="translate(38, 50)">
      <rect width="54" height="64" rx="6" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1.5" />
      <path d="M38 0 L54 16 L38 16 Z" fill="#E8F0FF" />
      <line x1="38" y1="0" x2="38" y2="16" stroke="#BFDBFE" strokeWidth="1" />
      <line x1="38" y1="16" x2="54" y2="16" stroke="#BFDBFE" strokeWidth="1" />
      <rect x="7" y="20" width="22" height="2.5" rx="1" fill="#E8E4DE" />
      <rect x="7" y="26" width="16" height="2" rx="1" fill="#E8E4DE" />
      <svg x="13" y="32" width="26" height="26" viewBox="0 0 100 100">
        <polygon points="10,10 90,10 90,90" fill="#1976FF" />
        <polygon points="10,55 50,55 50,90" fill="#1976FF" />
        <polygon points="10,72 30,72 30,90" fill="#1976FF" />
      </svg>
    </g>
    <text x="65" y="125" textAnchor="middle" fontWeight="600" fontSize="7" fill="#6B7280">
      Sh-lead-finder.zip
    </text>

    {/* Arrow */}
    <g transform="translate(100, 82)">
      <line x1="0" y1="0" x2="44" y2="0" stroke="#1976FF" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="36,-5 44,0 36,5" fill="none" stroke="#1976FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>

    {/* Downloads folder (right) with file landing inside */}
    <g transform="translate(152, 55)">
      <path d="M0 10a5 5 0 0 1 5-5h15l5 5h49a5 5 0 0 1 5 5v44a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z" fill="#FFE9B3" stroke="#F59E0B" strokeWidth="1.5" />
      <path d="M0 20h79v38a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z" fill="#FFD580" stroke="#F59E0B" strokeWidth="1.5" />
      <g transform="translate(24, 25)" style={{ transformOrigin: '16px 14px', animation: 'sh-icon-pop 2s ease-out infinite' }}>
        <rect width="32" height="24" rx="3" fill="white" stroke="#E8E4DE" strokeWidth="1" />
        <svg x="7" y="4" width="18" height="16" viewBox="0 0 100 100">
          <polygon points="10,10 90,10 90,90" fill="#1976FF" />
          <polygon points="10,55 50,55 50,90" fill="#1976FF" />
          <polygon points="10,72 30,72 30,90" fill="#1976FF" />
        </svg>
      </g>
    </g>
    <text x="192" y="128" textAnchor="middle" fontWeight="600" fontSize="7.5" fill="#6B7280">
      Downloads
    </text>
  </svg>
);

// Step 2 — Extract the ZIP file (right-click → Extract All → folder)
export const UnzipIllustration: React.FC = () => (
  <svg viewBox="0 0 280 140" className="bs-lf-ext__svg" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="280" height="140" rx="10" fill="#FAF8F4" />

    {/* ZIP file (left) */}
    <g transform="translate(10, 48)">
      <rect width="46" height="58" rx="5" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1.5" />
      <path d="M32 0 L46 14 L32 14 Z" fill="#E8F0FF" />
      <line x1="32" y1="0" x2="32" y2="14" stroke="#BFDBFE" strokeWidth="1" />
      <line x1="32" y1="14" x2="46" y2="14" stroke="#BFDBFE" strokeWidth="1" />
      <rect x="6" y="18" width="18" height="2" rx="1" fill="#E8E4DE" />
      <rect x="6" y="23" width="12" height="1.5" rx="0.5" fill="#E8E4DE" />
      <svg x="9" y="28" width="26" height="24" viewBox="0 0 100 100">
        <polygon points="10,10 90,10 90,90" fill="#1976FF" />
        <polygon points="10,55 50,55 50,90" fill="#1976FF" />
        <polygon points="10,72 30,72 30,90" fill="#1976FF" />
      </svg>
    </g>
    <text x="33" y="118" textAnchor="middle" fontWeight="600" fontSize="6" fill="#6B7280">
      Sh-lead-finder.zip
    </text>

    {/* Cursor on ZIP file */}
    <g transform="translate(42, 90)">
      <path d="M0 0 L0 13 L3.5 10 L6 15 L8 14 L5.5 9 L10 9 Z" fill="#1F2937" stroke="#FFFFFF" strokeWidth="0.6" />
    </g>

    {/* Right-click context menu */}
    <g transform="translate(55, 22)">
      <rect x="3" y="3" width="106" height="94" rx="6" fill="rgba(17,24,39,0.10)" />
      <rect width="106" height="94" rx="6" fill="#FFFFFF" stroke="#E5E2DC" strokeWidth="1" />
      <text x="12" y="22" fontWeight="500" fontSize="9" fill="#374151">Open</text>
      <text x="12" y="36" fontWeight="500" fontSize="9" fill="#374151">Open with</text>
      <line x1="6" y1="42" x2="100" y2="42" stroke="#E8E4DE" strokeWidth="0.8" />
      <rect x="4" y="45" width="98" height="17" rx="3" fill="#1976FF" />
      <text x="12" y="57" fontWeight="700" fontSize="9" fill="#FFFFFF">Extract All...</text>
      <polyline points="90,50 93,54 99,48" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="6" y1="65" x2="100" y2="65" stroke="#E8E4DE" strokeWidth="0.8" />
      <text x="12" y="77" fontWeight="500" fontSize="9" fill="#9CA3AF">Copy</text>
      <text x="12" y="89" fontWeight="500" fontSize="9" fill="#9CA3AF">Properties</text>
    </g>

    {/* Arrow → folder */}
    <g transform="translate(165, 79)">
      <line x1="0" y1="0" x2="30" y2="0" stroke="#1976FF" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="23,-5 30,0 23,5" fill="none" stroke="#1976FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>

    {/* Extracted folder (right) with logo file popping out */}
    <g transform="translate(200, 48)">
      <path d="M0 8a4 4 0 0 1 4-4h13l4 4h42a4 4 0 0 1 4 4v38a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" fill="#FFE9B3" stroke="#F59E0B" strokeWidth="1.5" />
      <path d="M0 16h67v34a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z" fill="#FFD580" stroke="#F59E0B" strokeWidth="1.5" />
      <g transform="translate(17, 28)" style={{ transformOrigin: '16px 11px', animation: 'sh-icon-pop 2.5s ease-out infinite' }}>
        <rect width="32" height="22" rx="3" fill="white" stroke="#E8E4DE" strokeWidth="1" />
        <svg x="7" y="3" width="18" height="16" viewBox="0 0 100 100">
          <polygon points="10,10 90,10 90,90" fill="#1976FF" />
          <polygon points="10,55 50,55 50,90" fill="#1976FF" />
          <polygon points="10,72 30,72 30,90" fill="#1976FF" />
        </svg>
      </g>
    </g>
    <text x="234" y="118" textAnchor="middle" fontWeight="600" fontSize="6.5" fill="#6B7280">
      Sh-lead-finder
    </text>
  </svg>
);

// Step 3 — Open chrome://extensions, turn on Developer mode
export const ChromeExtensionsIllustration: React.FC = () => (
  <svg viewBox="0 0 280 140" className="bs-lf-ext__svg" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="280" height="140" rx="10" fill="#FAF8F4" />
    <rect x="14" y="14" width="252" height="112" rx="8" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1" />
    <rect x="14" y="14" width="252" height="22" rx="8" fill="#F3F0EA" />
    <rect x="14" y="28" width="252" height="8" fill="#F3F0EA" />
    <circle cx="24" cy="25" r="3" fill="#FF5F57" />
    <circle cx="34" cy="25" r="3" fill="#FEBC2E" />
    <circle cx="44" cy="25" r="3" fill="#28C840" />
    <rect x="56" y="20" width="200" height="10" rx="3" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="0.5" />
    <text x="62" y="28" fontFamily="ui-monospace, monospace" fontWeight="500" fontSize="7" fill="#1F2937">
      chrome://extensions
    </text>
    <text x="28" y="56" fontWeight="700" fontSize="12" fill="#1F2937">
      Extensions
    </text>
    <g transform="translate(155, 46)">
      <rect width="100" height="20" rx="4" fill="#FAF8F4" />
      <text x="6" y="13" fontWeight="600" fontSize="8" fill="#1F2937">
        Developer mode
      </text>
      <g transform="translate(74, 5)">
        <rect width="22" height="10" rx="5" style={{ animation: 'sh-toggle-bg 2.4s ease-in-out infinite' }} fill="#D1D5DB" />
        <circle cx="5" cy="5" r="4" fill="#FFFFFF" style={{ animation: 'sh-toggle-on 2.4s ease-in-out infinite' }} />
      </g>
    </g>
    <g transform="translate(195, 75)">
      <path d="M0 0 Q5 12 18 -5" fill="none" stroke="#1976FF" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 2" />
      <polygon points="14,-3 18,-5 18,-1" fill="#1976FF" />
    </g>
    <text x="180" y="98" fontWeight="700" fontSize="9" fill="#1976FF">
      Toggle this on
    </text>
    <rect x="28" y="76" width="120" height="44" rx="4" fill="#FAF8F4" stroke="#E8E4DE" strokeWidth="0.5" strokeDasharray="3 2" />
    <text x="88" y="103" textAnchor="middle" fontWeight="500" fontSize="7" fill="#9CA3AF">
      No extensions installed yet
    </text>
  </svg>
);

// Step 4 — Click 'Load unpacked' and pick the folder
export const LoadUnpackedIllustration: React.FC = () => (
  <svg viewBox="0 0 280 140" className="bs-lf-ext__svg" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="280" height="140" rx="10" fill="#FAF8F4" />
    <rect x="14" y="14" width="252" height="112" rx="8" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1" />
    <rect x="14" y="14" width="252" height="22" rx="8" fill="#F3F0EA" />
    <rect x="14" y="28" width="252" height="8" fill="#F3F0EA" />
    <circle cx="24" cy="25" r="3" fill="#FF5F57" />
    <circle cx="34" cy="25" r="3" fill="#FEBC2E" />
    <circle cx="44" cy="25" r="3" fill="#28C840" />
    <g transform="translate(28, 46)">
      <g style={{ animation: 'sh-button-press 2.4s ease-in-out infinite' }}>
        <rect width="70" height="18" rx="4" fill="#FFFFFF" stroke="#1976FF" strokeWidth="1" />
        <text x="35" y="12" textAnchor="middle" fontWeight="700" fontSize="8" fill="#1976FF">
          Load unpacked
        </text>
      </g>
      <rect x="78" y="0" width="56" height="18" rx="4" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1" />
      <text x="106" y="12" textAnchor="middle" fontWeight="500" fontSize="8" fill="#6B7280">
        Pack
      </text>
      <rect x="142" y="0" width="56" height="18" rx="4" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="1" />
      <text x="170" y="12" textAnchor="middle" fontWeight="500" fontSize="8" fill="#6B7280">
        Update
      </text>
    </g>
    <g transform="translate(28, 76)" style={{ animation: 'sh-icon-pop 2.4s ease-out infinite', transformOrigin: '50px 22px' }}>
      <rect width="100" height="44" rx="4" fill="#FFFFFF" stroke="#E8E4DE" strokeWidth="0.5" />
      <g transform="translate(10, 10)">
        <svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <polygon points="10,10 90,10 90,90" fill="#1976FF" />
          <polygon points="10,55 50,55 50,90" fill="#1976FF" />
          <polygon points="10,72 30,72 30,90" fill="#1976FF" />
        </svg>
      </g>
      <text x="40" y="20" fontWeight="700" fontSize="8" fill="#1F2937">
        Saleshandy
      </text>
      <text x="40" y="32" fontWeight="500" fontSize="7" fill="#6B7280">
        v2.0.1
      </text>
    </g>
    <g style={{ animation: 'sh-cursor-move-1 2.4s ease-in-out infinite' }}>
      <path d="M0 0 L0 14 L4 11 L7 16 L9 15 L6 10 L11 10 Z" fill="#1F2937" stroke="#FFFFFF" strokeWidth="0.5" />
    </g>
  </svg>
);
